package amazon.lastmile.inject

import app.nestbridge.feature.invitations.ui.InvitationConfirmationUiFactory
import com.slack.circuit.runtime.ui.Ui
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = InvitationConfirmationUiFactory::class)
public interface AppNestbridgeFeatureInvitationsUiInvitationConfirmationUiFactory {
  @Provides
  @IntoSet
  public fun provideInvitationConfirmationUiFactoryFactoryMultibinding(invitationConfirmationUiFactory: InvitationConfirmationUiFactory): Ui.Factory = invitationConfirmationUiFactory
}
